import { Controller } from '@hotwired/stimulus';
import logger from '../../../app/javascript/analytics/logger';

export default class extends Controller {
  static targets = [
    'details',
    'filters',
    'actions',
    'dayInput',
    'nextButton',
    'schedule',
    'exploreButton'
  ];

  static values = {
    id: String,
    path: String
  };

  open() {
    const details = document.getElementById(this.idValue);
    details.classList.add('u-isVisible');
    details.innerHTML = event.detail[0].body.innerHTML;
    document.body.style.overflow = 'hidden';
    this.addOverlay();
    logger.trackElementClicked({
      label: `Class Details [${this.idValue}]`,
      elementId: 'Class finder results'
    });
  }

  close() {
    this.element.classList.remove('u-isVisible');
    this.removeOverlay();
    document.body.style.overflow = 'hidden scroll';
    logger.trackElementClicked({
      label: 'Close Details',
      elementId: 'Class finder results'
    });
  }

  addOverlay() {
    const div = document.createElement('div');
    div.setAttribute('class', 'Overlay');
    div.setAttribute('data-classes-guide-id', this.idValue);
    div.setAttribute('data-controller', 'classes-guide');
    div.setAttribute('data-action', 'click->classes-guide#detectOverlayClick');
    document.body.appendChild(div);
  }

  removeOverlay() {
    const div = document.querySelector('.Overlay');
    div.parentNode.removeChild(div);
  }

  detectOverlayClick() {
    document.getElementById(this.idValue).classList.remove('u-isVisible');
    this.close();
  }

  getCampaign() {
    const queryParams = new URLSearchParams(window.location.search);
    let campaign = '';
    if (queryParams.has('campaign')) {
      campaign = queryParams;
    }
    return campaign;
  }

  buildLink() {
    this.nextButtonTarget.href = `${this.pathValue}/${
      event.target.id
    }?${this.getCampaign()}`;
    this.showActions();
  }

  buildVariationLink() {
    let path;
    if (event.target.id.includes('in-person')) {
      path = 'in-person';
    } else if (event.target.id.includes('virtual')) {
      path = 'virtual';
    }
    this.exploreButtonTarget.href = `${
      this.pathValue
    }/${path}?${this.getCampaign()}`;
    this.exploreButtonTarget.removeAttribute('disabled');
    this.exploreButtonTarget.classList.remove('pointer-events-none');
  }

  buildDays({ selectedDays = [] }) {
    this.dayInputTargets.forEach((target) => {
      if (target.checked) {
        selectedDays.push(target.value);
      }
    });

    if (selectedDays.length) {
      this.nextButtonTarget.href = `${
        this.pathValue
      }?days=${selectedDays}&${this.getCampaign()}`;
      this.showActions();
    } else {
      this.hideActions();
    }
  }

  showActions() {
    this.actionsTarget.classList.remove('u-visuallyHidden');
  }

  hideActions() {
    this.actionsTarget.classList.add('u-visuallyHidden');
  }

  toggleFilters() {
    this.filtersTarget.classList.toggle('u-isVisible');
  }

  changeTimezone() {
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('timezone', event.target.value);
    this.refresh(queryParams);
  }

  changeSelectedDays({ selectedDays = [] }) {
    const queryParams = new URLSearchParams(window.location.search);

    this.dayInputTargets.forEach((target) => {
      if (target.checked) {
        selectedDays.push(target.value);
      }
    });

    if (selectedDays.length) {
      queryParams.set('days', selectedDays);
    } else {
      queryParams.delete('days');
    }

    this.refresh(queryParams);
  }

  refresh(params) {
    history.replaceState(null, null, `?${params.toString()}`);
    location.reload();
  }

  toggleSchedule() {
    this.scheduleTarget.classList.toggle('u-visuallyHidden');

    if (this.scheduleTarget.classList.contains('u-visuallyHidden')) {
      event.target.textContent = 'Show Full Schedule';
      logger.trackElementClicked({
        label: 'Hide Schedule',
        elementId: 'Class finder details'
      });
    } else {
      event.target.innerHTML = '&times; Hide';
      logger.trackElementClicked({
        label: 'Full Schedule',
        elementId: 'Class finder details'
      });
    }
  }

  onJoinClick() {
    logger.trackElementClicked({
      label: 'Join the Class',
      elementId: 'Class finder details'
    });
  }

  onSocialShare(event) {
    const { social } = event.params;

    logger.trackElementClicked({
      label: `Share on ${social}`,
      elementId: 'Class finder details'
    });
  }
}
